import Header from "../header/Header";
import Footer from "../footer/Footer";
import { Fragment } from "react";
function MainContent(props) {
  return (
    <Fragment>
      <Header />
      {props.children}
      <Footer />
    </Fragment>
  );
}

export default MainContent;
